let toHoursAndMinutes = (totalMinutes) => {
    const minutes = totalMinutes % 60;
    const hours = Math.floor(totalMinutes / 60);

    return `${padTo2Digits(hours)}:${padTo2Digits(minutes)}`;
}

let padTo2Digits = (num) => {
    return num.toString().padStart(2, '0');
}

let getTimeSelectors = () => {
    let minutes = 0,
        multiples = 15,
        maxTime = 60 * 8, // Máximo de 8 horas.
        optionsArr = [];

    // LOOP
    for (minutes; minutes <= maxTime; minutes += multiples) {
        optionsArr.push({
            value: minutes,
            text: toHoursAndMinutes(minutes)
        })
    }
    return optionsArr;
}

export { getTimeSelectors }